enum ToolbarToolType {
    AddNetworkNode = 'AddNetworkNode',
    AddNetworkLink = 'AddNetworkLink',
    ExtendRoutePath = 'ExtendRoutePath',
    CopyRoutePathSegment = 'CopyRoutePathSegment',
    RemoveRoutePathLink = 'RemoveRoutePathLink',
    EditNetworkNode = 'EditNetworkNode',
    Print = 'Print',
    SelectNetworkEntity = 'SelectNetworkEntity',
    SplitLink = 'SplitLink',
}

export default ToolbarToolType;
